import { Link } from 'react-router-dom';

const FRIEND_LINKS = [
  { label: '亚洲电影资料库', to: '/category/movie' },
  { label: '中文字幕专区', to: '/category/tv' },
  { label: '日韩影迷社区', to: '/category/movie/日本' },
  { label: '华语剧集榜单', to: '/category/tv/中国' },
  { label: '影视版权科普', to: '/about' },
];

export default function SiteIntro() {
  return (
    <section className="w-full px-4 md:px-8 py-8 md:py-10">
      <div className="rounded-lg bg-background-100 border border-background-200 p-6 md:p-8 grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2">
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">
            关于本站 · 亚洲中文字幕在线观看
          </h2>
          <p className="mt-4 text-sm text-foreground-600 leading-7">
            本站专注于提供高清亚洲影视资源的在线观看服务，覆盖中国、日本、韩国、泰国、香港、台湾等多个国家和地区的电影与电视剧作品，
            全部内容配有中文字幕，方便不同语言的观众轻松理解剧情。我们注重内容的准确分类与信息完整，力求让每一位影视爱好者都能快速找到自己想看的作品。
          </p>
          <p className="mt-3 text-sm text-foreground-500 leading-7">
            <span className="text-foreground-800 font-medium">版权声明：</span>
            本站为演示站点，页面上所有影视作品名称、简介、演职人员及相关资料均为虚构内容，仅用于展示网站结构与交互效果，
            不提供任何真实视频播放、下载或资源分发服务，如有雷同纯属巧合。
          </p>
          <div className="mt-5 flex flex-wrap gap-3">
            <Link
              to="/about"
              className="px-5 h-10 flex items-center gap-2 rounded-md bg-primary-500 text-background-950 text-sm font-medium hover:bg-primary-600 cursor-pointer whitespace-nowrap transition-colors"
            >
              <i className="ri-information-line"></i>
              了解更多
            </Link>
            <Link
              to="/help"
              className="px-5 h-10 flex items-center gap-2 rounded-md border border-background-300 text-foreground-700 text-sm font-medium hover:bg-background-200 cursor-pointer whitespace-nowrap transition-colors"
            >
              <i className="ri-question-line"></i>
              常见问题
            </Link>
          </div>
        </div>
        <div>
          <h3 className="text-sm font-semibold text-foreground-950 flex items-center gap-2">
            <i className="ri-link text-primary-500"></i>
            友情链接
          </h3>
          <ul className="mt-4 space-y-1">
            {FRIEND_LINKS.map((link) => (
              <li key={link.label}>
                <Link
                  to={link.to}
                  className="flex items-center gap-2 px-3 py-2 rounded-md text-sm text-foreground-600 hover:text-primary-500 hover:bg-background-200/60 cursor-pointer transition-colors"
                >
                  <i className="ri-arrow-right-s-line text-foreground-400"></i>
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}